// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'approvals'

/**
 * Approval Model Interface (auto-generated from Drizzle schema)
 */
export interface ApprovalModel {
  id: string
  orgId: string
  workspaceId: string
  userId: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  projectId: string
  milestoneId: string
  taskId: string
  documentId: string
  title: string
  type: string
  category: string
  categoryName: string
  status: string
  documentType?: string
  documentContent?: string
  response?: string
  annotations?: string
  comments?: string
  respondedAt?: string
  approverId?: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "projectId": {
          "type": "string",
          "maxLength": 100
      },
      "milestoneId": {
          "type": "string",
          "maxLength": 100
      },
      "taskId": {
          "type": "string",
          "maxLength": 100
      },
      "documentId": {
          "type": "string",
          "maxLength": 100
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "type": {
          "type": "string",
          "maxLength": 200
      },
      "category": {
          "type": "string",
          "maxLength": 200
      },
      "categoryName": {
          "type": "string",
          "maxLength": 200
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "documentType": {
          "type": "string",
          "maxLength": 200
      },
      "documentContent": {
          "type": "string",
          "maxLength": 50000
      },
      "response": {
          "type": "string",
          "maxLength": 5000
      },
      "annotations": {
          "type": "string",
          "maxLength": 5000
      },
      "comments": {
          "type": "string",
          "maxLength": 50000
      },
      "respondedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "approverId": {
          "type": "string",
          "maxLength": 100
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "projectId",
      "title",
      "type",
      "category",
      "categoryName",
      "status",
      "userId",
      "workspaceId",
      "milestoneId",
      "taskId",
      "documentId"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "userId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "workspaceId",
          "createdAt"
      ],
      [
          "projectId",
          "createdAt"
      ],
      [
          "milestoneId",
          "createdAt"
      ],
      [
          "taskId",
          "createdAt"
      ],
      [
          "documentId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
